
const Footer = () => {
  return (
    <div>
        <footer>
           ©️ Copyright 2023, CGNET | CG Communications Limited. All Rights Reserved            
        </footer>
    </div>
  )
}

export default Footer